<template>
  <div>
    <div v-if="!workerId" class="page-title-container lighter-shadow">
      <i class="fa fa-file-alt icon"></i>
      <h1>Списък на документи</h1>
    </div>
    <div class="filters-container">
      <SelectDropDown v-if="documentDefinitions"
                      class="document-dropdown"
                      :id="'documentName'"
                      :name="'documentName'"
                      :options="documentDefinitions"
                      :defaultSelected="documentDefinitions[0]"
                      :label="'Тип документ'"
                      @selection-change="documentDefinitionChange"
      />
      <GeneralStatusDropdown :id="'status'"
                             :name="'status'"
                             style="margin-left: 50px; width: 200px;"
                             class="document-dropdown"
                             @selection-change="setStatus"
                             :label="'Статус'"/>
      <div class="document-datepicker-container">
        <label class="document-datepicker-label">Дата на изтичане</label>
        <date-picker v-model="tempDate"
                     type="date"
                     :format="'DD-MM-YYYY'"
                     :lang="{formatLocale: getFormatLocale()}"
                     class="document-datepicker"
                     placeholder="Изберете дата">
        </date-picker>
      </div>
    </div>
    <div class="filters-container">
       <Checkbox id="'isExpired'"
                class="checkbox-expired"
                :initialValue="this.filters.expired"
                :newValue="this.filters.expired"
                @value-change="checkExpired"
                :label="'Покажи изтекли'"/>
      <Checkbox id="'isUnlimited'"
                class="checkbox-expired"
                :initialValue="this.filters.unlimited"
                :newValue="this.filters.unlimited"
                @value-change="checkUnlimited"
                :label="'Покажи безсрочни'"/>
    </div>
    <Grid class="grid"
          :config="config"
          :gridData="gridData"
          :loading="isLoading"
          @row-clicked="rowClicked">
    </Grid>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import redirectService from "@/services/redirect.service";
import documentService from "@/services/document.service";
import documentGridConfig from "./document-list-grid.config";
import workerDocumentGridConfig from "./worker-document-list-grid.config";
import SelectDropDown from "@/shared/components/form/SelectDropDown";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import dateService from "@/services/date.service";
import Checkbox from "@/shared/components/form/Checkbox";

export default {
  name: "DocumentList",
  components: {Checkbox, SelectDropDown, Grid, DatePicker},
  created() {
    this.filters.workerId = this.workerId;
    if (this.workerId) {
      this.config = workerDocumentGridConfig;
    } else {
      this.config = documentGridConfig;
    }

    documentService.fetchDocumentDefinitions()
        .then(({data}) => {
          this.documentDefinitions = [];
          this.documentDefinitions.push({
            id: 'none',
            name: '(всички)'
          });
          data.forEach(definition => this.documentDefinitions.push(definition));
        });
  },
  data() {
    return {
      workerId: this.$route.params.id,
      config: documentGridConfig,
      gridData: [],
      isLoading: true,
      filters: {
        workerId: null,
        expired: false,
        documentDefinitionId: null,
        expiringBefore: null,
        unlimited: null,
        status: null
      },
      documentDefinitions: null,
      tempDate: null
    }
  },
  methods: {
    documentDefinitionChange(value) {
      if (value.currentValue.id !== 'none') {
        this.filters.documentDefinitionId = value.currentValue.id;
      } else {
        if (value.currentValue.id === 'none') {
          this.filters.documentDefinitionId = null;
        }
      }
    },
    checkExpired(value) {
      this.filters.expired = value.isChecked;
      if (value.isChecked) {
        this.filters.unlimited = false;
      }
    },
    checkUnlimited(value) {
      this.filters.unlimited = value.isChecked;
      if (value.isChecked) {
        this.filters.expired = false;
        this.tempDate = null;
      }
    },
    setStatus(value) {
      if (value.currentValueId) {
        this.filters.status = value.currentValueId;
      } else {
        this.filters.status = null;
      }
    },
    fetchDocuments(filters) {
      documentService.fetchDocuments(filters)
          .then(response => {
            if (response.data) {
              this.gridData = response.data;
              this.isLoading = false;
            }
          });
    },
    rowClicked(row) {
      redirectService.redirectToDocument(row.id);
    },
    getFormatLocale() {
      return dateService.getFormatLocale();
    }
  },
  watch: {
    filters: {
      handler(newVal) {
        this.fetchDocuments(newVal);
      },
      deep: true
    },
    tempDate: {
      handler(newVal) {
        if (newVal) {
          this.filters.unlimited = false;
          this.filters.expiringBefore = dateService.formatDateISO(newVal);
        } else {
          this.filters.expiringBefore = null;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.grid {
  margin-top: 30px;
  display: inline-block;
}

.filters-container {
  display: inline-block;
  width: 100%;
}

.document-dropdown {
  width: 400px;
  float: left;
}

.document-datepicker-container {
  width: 250px;
  float: left;
  margin-left: 50px;
}

.document-datepicker {
  width: 250px;
  margin-top: 15px;
  cursor: pointer;
}

.document-datepicker-label {
  float: left;
  height: 30px;
  width: 100%;
  text-align: left;
  margin-left: 5px;
  font-size: 20px;
  color: var(--dark-grey);
}

.checkbox-expired {
  margin-top: 25px;
  width: 300px;
  float: left;
  display: inline-block;
}
</style>
